import Vue from 'vue'
import Router from 'vue-router'
import BannerTabs from '@/pages/BannerTabs'
import BannerDetail from '@/pages/BannerDetail'
import One from '@/components/One'
import Two from '@/components/Two'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/tabs'
    },
    {
      path: '/tabs',
      name: 'BannerTabs',
      component: BannerTabs
    },
    {
      path: '/detail',
      name: 'BannerDetail',
      component: BannerDetail
    },
    {
      path: '/one',
      name: 'One',
      component: One
    },
    {
      path: '/two',
      name: 'Two',
      component: Two
    }
  ]
})

router.beforeEach((to, from, next) => {
  // console.log('to>>>>>>>>>>>', to)
  // console.log('from>>>>>>>>>>>', from)
  // console.log('next>>>>>>>>>>>', next)
  next();
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js